<template>
    <div class="kadru_inside" v-if="head_items.length > 0">
        <legend>Кадри</legend>
        <div class="memorandum_info">
            
            <div class="kadru_data">
                <div class="head">
                    <div class="field " :class="head_item.class" v-for="head_item in head_items">
                        <div class="title_min">
                            {{head_item.name}}
                        </div>
                    </div>
                    <div class="clr"></div>
                </div>
                
                <div class="before_change">
                    <div class="pre_title pl-0">До змін</div>
                    <div class="dpartm">{{department_before}}</div>
                    
                    <div class="fields_insert" v-if="work_items.hasOwnProperty('before')">
                        <kadr_field :key="'before_' + field.number"  :field="field" v-for="field in work_items.before"></kadr_field>
                        <div class="clr"></div>
                    </div>
                    
                    <kadr_field_total key="before_total" :field="work_items.before_total" v-if="work_items.hasOwnProperty('before_total')"></kadr_field_total>
                </div>
                
                <div class="before_change">
                    <div class="pre_title pl-0">Після змін</div>
                    <div class="dpartm">{{department_after}}</div>
                    
                    <div class="fields_insert" v-if="work_items.hasOwnProperty('after')">
                        <kadr_field :key="'after_' + field.number"  :field="field" v-for="field in work_items.after"></kadr_field>
                        <div class="clr"></div>
                    </div>
                    
                    <kadr_field_total key="after_total" :field="work_items.after_total" v-if="work_items.hasOwnProperty('after_total')"></kadr_field_total>
                </div>
            </div>
        </div>
    </div>
</template>

<script >
import Kadr_field from "./kadr_field.vue";
import Kadr_field_total from "./kadr_field_total.vue";

export default {
    name: "mem_inside_kadru",
    components: {Kadr_field_total, Kadr_field},
    props : {
        "addon_data" : {
            type : Object
        },
        
        'mem' : {
            type : Object
        },
    },
    
    data() {
        return  {
        
        }
    },
    
    computed : {
        
        head_items() {
            if(this.addon_data.hasOwnProperty('head_items')) {
                return this.addon_data.head_items;
            }
            
            return [];
        },
        
        work_items() {
            if(this.addon_data.hasOwnProperty('items')) {
                return this.addon_data.items;
            }
            
            return null;
        },
        
        department_before() {
            try {
                if (this.work_items) {
                    return this.work_items.department_before[0].service_ins;
                }
            }
            catch (e) {
            
            }
            return '';
        },
        
        department_after() {
            try {
                if (this.work_items) {
                    return this.work_items.department_after[0].service_ins;
                }
            }
            catch (e) {
            
            }
            return '';
        }
        
        
        
    },
    
}
</script>


<style scoped>

</style>